import { KeywordsList } from '@/pages/KeywordsList';
import { TagsList } from '@/pages/TagsList';
import { Flex } from '@tremor/react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import s from './DataForSeoEditConnector.module.scss';
import { DataForSeoConfigTab } from './DataForSeoConfigTab';
import { useEditAdAccounts } from '@/hooks/useEditAdAccounts';
import LoadingIndicator from '../../LoadingIndicator/LoadingIndicator';
import { OutlinedButton } from '../../Buttons/OutlinedButton/OutlinedButton';
import { restartConnectorCreationCloudFunction } from '@/firebase/init';
import { useOrganizationStore } from '@/stores/organizationStore';
import { useState } from 'react';
import { assert } from '@/utils/asserts';
import { ConnectorTitle } from '../ConnectorTitle/ConnectorTitle';

export function DataForSeoEditConnector() {
  const {
    connector,
    isLoading,
    register,
    onUpdateName,
    handleSubmit,
    isConnectorFailure,
    workspaceId,
    displayData,
    errors,
    isInitialSetup,
    connectorStatus,
  } = useEditAdAccounts();
  const selectedOrganization = useOrganizationStore(
    (state) => state.selectedOrganization,
  );
  const [isRestartingConnectorCreation, setIsRestartingConnectorCreation] =
    useState(false);
  const organizationId = selectedOrganization?.id;
  assert(organizationId, 'Organization not found');
  const adAccount = displayData[0];
  const isConnectorEnablingFailure = adAccount?.status === 'ACCOUNT_FAILURE';

  let content = (
    <Flex flexDirection="col" alignItems="start" className="gap-3">
      <ConnectorTitle isInitialSetup={isInitialSetup} connectorStatus={connectorStatus}>
        Data for SEO
      </ConnectorTitle>
      <Tabs className={s.wrapper}>
        <TabList>
          <Tab>Keywords</Tab>
          <Tab>Tags</Tab>
          <Tab>Config</Tab>
        </TabList>

        <TabPanel>
          <KeywordsList locationCode={connector.locationCode as number} />
        </TabPanel>
        <TabPanel>
          <TagsList />
        </TabPanel>
        <TabPanel>
          <DataForSeoConfigTab
            locationCode={connector.locationCode as number}
            timezone={connector.timezone as string}
            register={register}
            isLoading={isLoading}
            onSave={handleSubmit(onUpdateName)}
            errors={errors}
          />
        </TabPanel>
      </Tabs>
    </Flex>
  );
  if (isConnectorFailure || isConnectorEnablingFailure) {
    content = (
      <LoadingIndicator
        isLoading={false}
        wholeMessage="There was an error while creating this connector"
      >
        <OutlinedButton
          onClick={async () => {
            setIsRestartingConnectorCreation(true);
            try {
              await restartConnectorCreationCloudFunction({
                connectorId: connector?.id,
                workspaceId: workspaceId,
                organizationId: organizationId,
              });
            } finally {
              setIsRestartingConnectorCreation(false);
            }
          }}
          disabled={isRestartingConnectorCreation}
        >
          Retry
        </OutlinedButton>
      </LoadingIndicator>
    );
  }
  return content;
}
